import { render, staticRenderFns } from "./EditDriveItems.vue?vue&type=template&id=47349a01&"
import script from "./EditDriveItems.ts?vue&type=script&lang=ts&"
export * from "./EditDriveItems.ts?vue&type=script&lang=ts&"
import style0 from "./EditDriveItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports